import API from '@/api'
import { getToken, setToken, removeToken } from '@/utils/auth'

const state = {
  token: getToken(),
  userInfo: {},
  sid: '',
  captchaURL: '',
  graduationDate: '',
  thesisProcess: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = 'Bearer' + ' ' + token
  },
  SET_USER_INFO(state, data) {
    state.userInfo = {
      ...state.userInfo,
      ...data
    }
  },
  SET_SID(state, data) {
    state.sid = data
  },
  SET_CAPTCHA_URL(state, data) {
    state.captchaURL = data
  },
  SET_GRADUATION_DATE(scope, data) {
    scope.graduationDate = data
  },
  STE_THESIS_PROCESS_LIST(state, data) {
    state.thesisProcess = data
  }
}

const actions = {
  /* 登录 */
  Login({ commit, dispatch }, data) {
    return new Promise((resolve, reject) => {
      API.Login(data)
        .then(res => {
          setToken(res.data.token)
          commit('SET_USER_INFO', res.data.user)
          dispatch('common/UserPortalData', '', { root: true })
          dispatch('GetThesisNodeList').then(res => {
            // commit('STE_THESIS_PROCESS_LIST', res.data)
            window.location.reload()
          })
          resolve()
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  /* 获取论文节点 */
  GetThesisNodeList({ commit, dispatch }) {
    return new Promise((resolve, reject) => {
      API.MBAThesisNodeList().then(res => {
        if (+res.code === 200) {
          commit('STE_THESIS_PROCESS_LIST', res.data.data)
          resolve(res.data)
        }
      })
    })
  },
  /* 登出 */
  async Logout({ dispatch }) {
    await API.Logout()
    await dispatch('resetToken')
    location.reload()
  },
  /* 清空登录数据 */
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_USER_INFO', {})
      removeToken()
      window.sessionStorage.removeItem('student')
      resolve()
    })
  },
  /* 找回密码 创建会话 */
  async CreateSid({ commit, dispatch }) {
    const res = await API.CreateSid()
    if (+res.code === 200) {
      commit('SET_SID', res.data.sid)
      dispatch('Captcha', res.data.sid)
    }
  },
  /* 找回密码 图形验证码 */
  async Captcha({ commit, state }, sid) {
    const res = await API.Captcha(sid || state.sid)
    if (+res.code === 200) {
      commit('SET_CAPTCHA_URL', res.data.image)
    }
  },
  SendVerifyCode({ state }, data) {
    const postData = {
      sid: state.sid,
      ...data
    }
    return API.SendVerifyCode(postData)
  },
  restPasswod({ state, commit }, data) {
    const postData = {
      sid: state.sid,
      ...data
    }
    return API.restPasswod(postData)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
